<template>
	<component :is="this.context || 'div'" :data="this.sendData"></component>
</template>

<script>
import PracticeDashboardLandingZone from '@/components/ui/dashboard/practice/PracticeDashboardLandingZone';
// import PracticeLocationCard from '@/components/ui/dashboard/practice/cards/PracticeLocationCard';
// import PracticeDefaultCard from '@/components/ui/dashboard/practice/cards/PracticeDefaultCard';

import PracticeLocumSearch from '@/components/ui/dashboard/practice/cards/PracticeLocumSearch';
import PracticeLocumSearchResults from '@/components/ui/dashboard/practice/cards/PracticeLocumSearchResults';
import PracticeLocumProfileFound from '@/components/ui/dashboard/practice/cards/PracticeLocumProfileFound';

import PracticeLocumProfile from '@/components/ui/dashboard/practice/cards/PracticeLocumProfile';
import PracticeCreateOffer from '@/components/ui/dashboard/practice/cards/PracticeCreateOffer';
import PracticeToLocumBookingRequestSent from '@/components/ui/dashboard/practice/cards/PracticeToLocumBookingRequestSent';
import PracticeToLocumCreateOffer from '@/components/ui/dashboard/practice/cards/PracticeToLocumCreateOffer';
import PracticeToLocumCreateBookingRequest from '@/components/ui/dashboard/practice/cards/PracticeToLocumCreateBookingRequest';
import ViewLocumDetailsCard from '@/components/custom/ViewLocumDetailsCard';
import PracticeToLocumBookingSummary from '@/components/ui/dashboard/practice/cards/PracticeToLocumBookingSummary';
import PracticeToLocumBookingSummaryRemainders from '@/components/ui/dashboard/practice/cards/PracticeToLocumBookingSummaryRemainders';
import PracticeRequestMultipleLocums from '@/components/ui/dashboard/practice/cards/PracticeRequestMultipleLocums';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

//sucess cards
import PracticeSuccessOfferDeleted from '@/components/ui/dashboard/practice/cards/PracticeSuccessOfferDeleted';
import PracticeSuccessRequestCancelled from '@/components/ui/dashboard/practice/cards/PracticeSuccessRequestCancelled';
import PracticeSuccessRequestSent from '@/components/ui/dashboard/practice/cards/PracticeSuccessRequestSent';
import { bus } from '@/main';

// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import store from '@/store';

export default {
	name: 'PracticeDashboardMain',
	components: {
		// PracticeLocationCard,
		// PracticeDefaultCard,
		PracticeDashboardLandingZone,
		PracticeLocumSearch,
		PracticeLocumSearchResults,
		PracticeLocumProfileFound,
		PracticeLocumProfile,
		PracticeCreateOffer,
		//
		PracticeToLocumBookingRequestSent,
		PracticeToLocumCreateOffer,
		PracticeToLocumCreateBookingRequest,
		ViewLocumDetailsCard,
		PracticeToLocumBookingSummary,
		PracticeToLocumBookingSummaryRemainders,
		PracticeRequestMultipleLocums,

		DashboardDropdownSection,

		PracticeSuccessOfferDeleted,
		PracticeSuccessRequestCancelled,

		PracticeSuccessRequestSent,
	},
	data: () => ({
		context: 'practice-dashboard-landing-zone', //begin in landing zone
		API_URL: store.getters.getAPI,
		requestsSent: null,
		sendData: null,
	}),
	async created() {
		bus.$on('change-context', (new_context, data = null) => {
			this.context = new_context;
			this.sendData = data;
		});
	},
	methods: {
		async getRequestsSent() {
			const requestsSent = [];

			const token = store.getters.jwtToken; //get the token
			const company = store.getters.company;

			await axios.get(this.API_URL + '/offers/company/' + company.id + '/2020-01-01/2030-12-31/', { headers: { Authorization: token } }).then(response => {
				let requests = response.data.data.Items;

				store.dispatch('setPracticeBookingRequestsSent', requests);
			});

			this.requestsSent = requestsSent;
		},
	},
};
</script>
